import { render, staticRenderFns } from "./SharedThanks.vue?vue&type=template&id=0eec6dc0"
import script from "./SharedThanks.vue?vue&type=script&lang=js"
export * from "./SharedThanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports